"use strict";
/* eslint-disable init-declarations */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable sonarjs/cognitive-complexity */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEntryRetry = CommonEntryRetry;
const constants_1 = require("./constants");
function CommonEntryRetry({ options, retryFn, beforeExecuteRetry = (name) => { }, }) {
    if (options.hosts && options.hosts.length) {
        return DomainRotationRetry({
            options,
            retryFn,
            beforeExecuteRetry,
        });
    }
    return async function (args) {
        let retryResponse;
        let originalUrl;
        const { retryTimes = 3, retryDelay = 1000, onRetry, onError, onSuccess, } = options || {};
        let attempts = 0;
        while (attempts < retryTimes) {
            try {
                beforeExecuteRetry(args.remoteInfo.name);
                if (!originalUrl) {
                    originalUrl = args.remoteInfo.entry;
                }
                if (onRetry) {
                    onRetry(originalUrl, attempts);
                }
                retryResponse = await retryFn(args);
                if (onSuccess) {
                    onSuccess(originalUrl, attempts);
                }
                break;
            }
            catch {
                attempts++;
                if (onError) {
                    onError(originalUrl);
                }
                if (attempts >= retryTimes) {
                    throw new Error(`${constants_1.PLUGIN_IDENTIFIER}: ${constants_1.ERROR_ABANDONED} | url: ${originalUrl || 'unknown'}`);
                }
                await new Promise((resolve) => {
                    setTimeout(resolve, retryDelay);
                });
            }
        }
        return retryResponse;
    };
}
function DomainRotationRetry({ options, retryFn, beforeExecuteRetry = (name) => { }, }) {
    return async function (args) {
        let retryResponse;
        let originalUrl;
        let lastUrl;
        const { hosts = [], onRetry, onError, onSuccess } = options || {};
        if (!originalUrl) {
            originalUrl = args.remoteInfo.entry;
        }
        let attempts = 0;
        for (const nextHostname of hosts) {
            try {
                beforeExecuteRetry(args.remoteInfo.name);
                const parsed = URL.parse(args.remoteInfo.entry);
                let url;
                if (parsed) {
                    url = parsed;
                    if (nextHostname.endsWith(url.hostname)) {
                        continue;
                    }
                }
                else {
                    url = new URL(`${nextHostname}${args.remoteInfo.entry}`);
                }
                url.hostname = new URL(nextHostname).hostname;
                lastUrl = url.toString();
                if (onRetry) {
                    onRetry(url.toString(), attempts);
                }
                args.remoteInfo.entry = url.toString();
                args.remoteInfo.originalUrl = originalUrl;
                retryResponse = await retryFn(args);
                if (onSuccess) {
                    onSuccess(lastUrl, attempts);
                }
                return retryResponse;
            }
            catch {
                attempts++;
            }
        }
        if (onError) {
            onError(lastUrl);
        }
        throw new Error(`${constants_1.PLUGIN_IDENTIFIER}: ${constants_1.ERROR_ABANDONED} | originalUrl: ${originalUrl || 'unknown'}`);
    };
}
